/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FaceConfigurationDto } from "./Order/FaceConfigurationDto";

export class OrderDto {
    id: string;
    configurationCode: string;
    faceConfiguration: FaceConfigurationDto;
}
